import React, { useState } from "react";
import Sidebar from "../../common/components/Sidebar/sidebar";
import TimeLine from "../../common/components/TimeLine/TimeLine";
import RightSidebar from "../../common/components/RightSidebar/RightSidebar";
import StatusWaiver from "../../common/components/statusWaiver/StatusWaiver";
import DownloadModel from "../../common/components/downloadModel/DownloadModel";
import PLPassword from "../../common/components/plPassword/PLPassword";

const StatusWaiverConfirm = () => {
  const [isCount, setIsCount] = useState(4);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          {/* Sidebar */}
          <div className="col-12  col-lg-2 p-0">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-12  col-lg-10">
            {/* Timeline Header */}
            <div className="row">
              <div className="col-12 px-3 px-md-1 px-lg-1">
                <div className="headerTimeLine">
                  <TimeLine currentStep={isCount} />
                </div>
              </div>
            </div>

            {/* Status and Right Sidebar */}
            <div className="row">
              {/* StatusWaiver Section */}
              <div className="col-12 col-lg-9 d-flex justify-content-center align-items-center mt-3 mt-lg-0">
                <div className="statusWaiverMainContainer w-100 px-2">
                  <StatusWaiver isCount={isCount} />
                </div>
              </div>

              {/* Right Sidebar */}
              <div className="col-12 col-lg-3 mt-4 mt-lg-0">
                <div className="right_sidebar px-3 px-lg-2">
                  <RightSidebar
                    setIsCount={setIsCount}
                    islabel="STATUS WAIVER"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="container-fluid">
        <div className="row">
          <div className="col-lg-2 p-0 col-md-3">
            <Sidebar />
          </div>

          <div className="col-sm-10 col-lg-10">
            <div className="row align-items-center">
              <div className="headerTimeLine px-5">
                <TimeLine currentStep={isCount} />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-9 p-0 m-0 d-flex align-items-center justify-content-center">
                <div className="statusWaiverMainContainer">
                  <StatusWaiver isCount={isCount} />
                </div>
              </div>
              <div className="col-lg-3 p-0 right_col">
                <div className="right_sidebar">
                  <RightSidebar
                    setIsCount={setIsCount}
                    islabel={"STATUS WAIVER"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <PLPassword />
    </>
  );
};

export default StatusWaiverConfirm;
